import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Eye, EyeOff, Mail } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (event) => {
    event.preventDefault(); setBusy(true);
    try { await login(email, password); navigate("/"); }
    catch (error) { toast.error(errorMessage(error)); }
    finally { setBusy(false); }
  };

  return (
    <main className="login-page" data-testid="login-page">
      <section className="login-form-panel" data-testid="login-form-panel">
        <form onSubmit={submit} data-testid="login-form">
          <div className="field"><Label htmlFor="email">E-mail</Label><div className="input-icon"><Mail size={17} /><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Digite seu e-mail" required data-testid="login-email-input" /></div></div>
          <div className="field"><Label htmlFor="password">Senha</Label><div className="password-input"><Input id="password" type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Digite sua senha" required data-testid="login-password-input" /><button type="button" className="password-toggle" onClick={() => setShowPassword((value) => !value)} data-testid="login-password-toggle" aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}>{showPassword ? <EyeOff size={18} /> : <Eye size={18} />}</button></div></div>
          <Button type="submit" disabled={busy} className="primary-button" data-testid="login-submit-button">{busy ? "Entrando..." : "Entrar no painel"}</Button>
        </form>
      </section>
    </main>
  );
}